<template>
  <div id="tab-license-add-marine">
    <form>
      <div class="vx-row">
        <div class="vx-col w-1/4 mb-6 license-col-min-width">
          <label class="vs-input--label">免許区分</label>
          <v-select
            placeholder="免許区分を選択してください"
            class="w-full v-select-license-add"
            label="label"
            name="selectLicenseCategory"
            :options="marineLicenseCategoryOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="selectedCategory"
            v-validate="'required'"
            data-vv-as="免許区分"
          >
            <template v-slot:no-options>免許区分が見つかりません</template>
          </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('selectLicenseCategory')"
            >{{ errors.first("selectLicenseCategory") }}</span
          >
        </div>
        <div class="vx-col w-1/4 mb-6 license-col-min-width">
          <label class="vs-input--label">階級</label>
          <v-select
            placeholder="階級を選択してください"
            class="w-full v-select-license-add"
            label="label"
            name="selectClass"
            :disabled="selectClassDisabled"
            :options="marinerClassOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="inputForm.licenseTypeId"
            v-validate="'required'"
            data-vv-as="階級"
          >
            <template v-slot:no-options>階級が見つかりません</template>
          </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('selectClass')"
            >{{ errors.first("selectClass") }}</span
          >
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/4 license-col-min-width">
          <label class="vs-input--label">有効期限</label>
          <datepicker
            name="selectExpirationDate"
            :language="ja"
            :format="formatter"
            :typeable="true"
            placeholder="日付を選択してください"
            v-model="inputForm.expirationDate"
            v-validate="'required'"
            data-vv-as="有効期限"
            :disabled-dates="disabledDates"
            ref="datePickerExpirationDate"
          ></datepicker>
          <span
            class="text-danger text-sm"
            v-show="errors.has('selectExpirationDate')"
            >{{ errors.first("selectExpirationDate") }}</span
          >
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 mt-8 mb-8 w-full license-col-min-width">
          <input-image
            :label="'海技士免状の画像'"
            ref="inputImage"
            @onSetImage="onSetImage"
          ></input-image>
        </div>
        <div class="vx-col md:w-1/4 w-full input-form-memo">
          <label class="vs-input--label">メモ</label>
          <vs-textarea v-model="inputForm.memo" width="100%" height="200px"/>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import LicenseMixin from "@/mixins/LicenseMixin";
import DatepickerMixin from "@/mixins/DatepickerMixin";
import InputImage from "@/components/formElemens/input/InputImage";
import { FileUtil } from "@/utils";

const { mapActions } = createNamespacedHelpers("enterpriseLicenseAdd");

export default {
  components: {
    vSelect,
    Datepicker,
    InputImage
  },
  mixins: [LicenseMixin, DatepickerMixin],
  data() {
    return {
      selectClassDisabled: false,
      inputForm: {
        licenseTypeId: null,
        expirationDate: null,
        memo: null,
      },
      classification: [],
      selectedCategory: [],
      marinerClassOptions: [],
      disabledDates: {
        to: new Date(),
      },
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    selectedCategory(newValue, oldValue) {
      this.classification = [];
      this.clean();
      if (newValue !== null) {
        this.selectClassDisabled = false;
        this.marinerClassOptions = this.getMarinerClassOptions(
          this.selectedCategory.value
        );
      } else {
        this.marinerClassOptions = [];
        this.selectClassDisabled = true;
      }
    }
  },
  methods: {
    ...mapActions(["setInputForm", "setPictureSrc", "clearPictureSrc"]),

    onSetImage(evt) {
      let blob = FileUtil.toBlob(evt.src, evt.type);
      this.setPictureSrc(blob);
    },

    onClearImage() {
      this.clearPictureSrc();
    },

    async validate() {
      let result = await this.$validator.validateAll();
      if (result) {
        let payload = {
          name: this.selectedCategory.label,
          license_type_id: this.inputForm.licenseTypeId.value,
          expiration_date: this.inputForm.expirationDate,
          memo: this.inputForm.memo,
        };
        await this.setInputForm(payload);
      }
      return result;
    },

    clean() {
      this.inputForm.licenseTypeId = null;
      this.inputForm.expirationDate = null;
      this.inputForm.memo = null;
    }
  },
  mounted() {
    this.customizeExpirationDateElement(this.$refs.datePickerExpirationDate.$el);
  },
};
</script>

<style lang="scss">
.vs-button {
  .text-small {
    font-size: small;
  }
}

.text-font-bolder {
  font-weight: bolder;
}

.v-select-license-add {
  .vs__selected {
    padding: 0.24rem 0.24rem 0.24rem 0.62rem !important;
  }
  .vs__search {
    padding: 0.24rem 0.24rem 0.24rem 0.62rem !important;
  }
}

.vs__dropdown-toggle {
  border-radius: 5px;
}

.vs-upload--label {
  margin-top: 40px;
  margin-left: 15px;
  padding-left: 5px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
}

.con-upload-license-add {
  .con-img-upload {
    padding: 0;
  }
  .con-input-upload {
    margin-top: 0px;
    margin-left: 12px;
  }
}

#tab-license-add-marine {
  .license-col-min-width {
    min-width: 220px;
  }
  .input-form-memo {
    padding-top: 2rem;
    .vs-con-textarea {
      margin-top: 0.6rem;
    }
    .vs-textarea {
      height: 200px;
    }
  }
}

</style>
